export default __webpack_public_path__ + "static/media/iphone-frame.2aa36042.png";